// extracted by mini-css-extract-plugin
module.exports = {"fadeInAnimation":"AlertError_fadeInAnimation__12HBI","fadeIn":"AlertError_fadeIn__22M6F"};